import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {updateDocumentTitle} from "../../Utils/Common";
import PageLayout from "../Layout/PageLayout";
import {Button, StatCard, Spinner} from "../UI";
import {tokens} from "../../theme/tokens";

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: ${tokens.spacing[4]};
    a { text-decoration: none; display: block; }
`;

const Updated = styled.span`
    display: inline-flex;
    align-items: center;
    gap: ${tokens.spacing[2]};
    font-size: ${tokens.typography.size.sm};
    font-weight: ${tokens.typography.weight.semibold};
    color: ${tokens.colors.muted};
`;

const RequestOverview = props => {

    const [isLoading, setIsLoading] = useState(false);
    const [stats, setStats] = useState('');
    const [lastUpdated, setLastUpdated] = useState('');
    let lastLoaded = new Date();

    useEffect(() => {
        updateDocumentTitle("Requests overview")
        loadCounter()

        setInterval(() => {
            loadCounter()
        }, 60000)
    }, []);

    function loadCounter() {
        getTimeDifference()
        let data = new FormData();
        data.append("status", 1);
        setIsLoading(true)
        postData(Endpoints.REQUEST_STATS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setStats(res.data);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const getTimeDifference = () => {
        console.log("last loaded ", lastLoaded)
        let now = new Date();
        let diffMs = (now - lastLoaded);
        let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
        lastLoaded = new Date()
        setLastUpdated(`${diffMins} mins ago`)
    }

    const tiles = [
        {to: "/requests/incoming", label: "Incoming / new", value: stats.incoming, accent: true},
        {to: "/requests/assigned", label: "Assigned & not started", value: stats.assigned, accent: true},
        {to: "/requests/ongoing", label: "Ongoing", value: stats.ongoing, accent: true},
        {to: "/requests/rone", label: "At R1", value: stats.rone},
        {to: "/requests/rtwo", label: "At R2", value: stats.rtwo},
        {to: "/requests/cc", label: "At CC", value: stats.cc},
        {to: "/requests/rthree", label: "At R3", value: stats.rthree},
        {to: "/requests/rfour", label: "At R4", value: stats.rfour},
        {to: "/requests/late", label: "Late", value: stats.late},
        {to: "/requests/cancelled", label: "Cancelled", value: stats.cancelled},
        {to: "/requests/completed", label: "Completed", value: stats.completed},
        {to: "/requests/bounced", label: "Bounced", value: stats.bounced},
    ];

    return (
        <PageLayout
            title="Requests overview"
            actions={
                <>
                    <Updated>
                        {isLoading && <Spinner size={16}/>}
                        Last updated {lastUpdated}
                    </Updated>
                    <Button variant="outline" onClick={e => loadCounter()}>Reload</Button>
                </>
            }
        >
            <Grid>
                {tiles.map((t, k) => (
                    <Link to={t.to} key={k}>
                        <StatCard label={t.label} value={t.value != null ? t.value : 0} accent={!!t.accent}/>
                    </Link>
                ))}
            </Grid>
        </PageLayout>
    )
};

export default RequestOverview;
